export default "__VITE_ASSET__BLRQlnYy__"